/* Ott-common */
import { normalize } from '@dtvgo/typed-normalizr';
import { AuthType } from '@dtvgo/axios-interceptor-auth';

/* Utils */
import { VodContentEntity } from '../../utils';

export default function streams(backendAxiosInstance) {
  /**
   * @typedef StreamConcurrencyParams
   * @type {object}
   * @property {string} device
   * @property {string} progress
   * @property {string} metadataId
   * @property {number} duration
   * @property {number} streamed
   * @property {string} sessionId
   * @property {import('../../../../utils/constants-new').ContentType} contentType
   */

  /**
   * @param {string} assetId
   * @param {StreamConcurrencyParams} streamConcurrencyParams
   */
  function setStreamConcurrency(assetId, streamConcurrencyParams) {
    return backendAxiosInstance.put(
      `/experience/v1/Streams/${assetId}/streaming`,
      streamConcurrencyParams,
      {
        includeTimeZone: true,
        includeClientType: true,
        authType: AuthType.SESSION_TOKEN,
      },
    );
  }

  /**
   * @param {string} assetId
   * @param {StreamConcurrencyParams} streamConcurrencyParams
   */
  function stopStreamConcurrency(assetId, streamConcurrencyParams) {
    return backendAxiosInstance.put(
      `/experience/v1/Streams/${assetId}/stop`,
      streamConcurrencyParams,
      {
        includeTimeZone: true,
        includeClientType: true,
        authType: AuthType.SESSION_TOKEN,
      },
    );
  }

  /**
   * @param {string} assetId
   */
  function getStreamProgress(assetId) {
    return backendAxiosInstance.get(`/experience/v1/Streams/${assetId}`, {
      authType: AuthType.SESSION_TOKEN,
    });
  }

  async function getStreamsHistory() {
    const response = await backendAxiosInstance.get('/experience/v1/Streams/history', {
      authType: AuthType.SESSION_TOKEN,
    });

    response.normalizedData = normalize(
      response.data.map(({ assetId, ...rest }) => ({ id: assetId, ...rest })),
      [VodContentEntity],
    );

    return response;
  }

  return {
    setStreamConcurrency,
    stopStreamConcurrency,
    getStreamProgress,
    getStreamsHistory,
  };
}
